/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProductDocumentViewModel } from './ProductDocumentViewModel';
import {
    ProductDocumentViewModelFromJSON,
    ProductDocumentViewModelFromJSONTyped,
    ProductDocumentViewModelToJSON,
} from './ProductDocumentViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfProductDocumentViewModel
 */
export interface ResultOfProductDocumentViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfProductDocumentViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProductDocumentViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfProductDocumentViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProductDocumentViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProductDocumentViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfProductDocumentViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfProductDocumentViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ProductDocumentViewModel}
     * @memberof ResultOfProductDocumentViewModel
     */
    data?: ProductDocumentViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfProductDocumentViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfProductDocumentViewModel interface.
 */
export function instanceOfResultOfProductDocumentViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfProductDocumentViewModelFromJSON(json: any): ResultOfProductDocumentViewModel {
    return ResultOfProductDocumentViewModelFromJSONTyped(json, false);
}

export function ResultOfProductDocumentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfProductDocumentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ProductDocumentViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfProductDocumentViewModelToJSON(value?: ResultOfProductDocumentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ProductDocumentViewModelToJSON(value.data),
        'Count': value.count,
    };
}

